import React from 'react';
import { Route, IndexRoute } from 'react-router';
import UnAuthenticatedLayout from './layout/UnAuthenticatedLayout';
import { logout } from './auth/AuthActions';
import { hasFeature } from './utils/featureFlags';

var routesWithGuardData = [
    {
        url: '/team',
        permission: 'MANAGE_PARTNERS'
    },
    {
        url: '/clients'
    },
    {
        url: '/'
    },
    {
        url: '/settings'
    },
    {
        url: '/find_invoices'
    },
    {
        url: '/discounts',
        permission: 'VIEW_DISCOUNTS',
        // default-off admin rollout flag on top of the permission (OPE-112)
        feature: 'discountsAdmin'
    }
];

export function canViewRoute(url, user) {
    var urlData = routesWithGuardData.find(r => r.url == url);
    if(! urlData) {
        throw `Url: ${url} not found in routesWithGuardData`;
    }

    var hasPermission = urlData.permission ? userHasPermission(user, urlData.permission) : true;
    var hasOrganisation = urlData.organisation ? urlData.organisation == user.organisationName : true;
    var hasRole = urlData.role ? urlData.role == user.userRole.name : true;
    var featureOn = urlData.feature ? hasFeature(user, urlData.feature) : true;

    return hasPermission && hasOrganisation && hasRole && featureOn;
}


function userHasPermission(user, permission) {
    return user.permissions.includes(permission);
}

export default (store) => {
    const requireLogin = (nextState, replace, cb) => {
        const { auth: { user }} = store.getState();

        if (!user) {
            replace('/login');
            store.dispatch(logout());
        }

        cb();
    };

    function canView(url) {
        return function middlewareHandler(nextState, replace, cb) {
            const { auth: { user }} = store.getState();

            if(! canViewRoute(url, user)) {
                replace('/unauthorised');
            }

            cb();
        }
    }

    // These approaches might be better for laying out routes
    // https://github.com/dayAlone/Russell/blob/eeab5a27d351a38f9a2391491ef28973e9f05ad8/client/js/routes/index.js
    // https://github.com/reactjs/react-router/blob/master/examples/huge-apps/app.js

    return (
        <Route path="/">

            {/* Routes requiring login */}
            <Route onEnter={requireLogin} component={require('./App')}>
                <IndexRoute component={require('./pages/dashboard/Dashboard')} />

                <Route path="/clients" component={require('./pages/Clients')}   />
                <Route path="/clients/from_fergus/:id" component={require('./pages/ClientRedirect')} />
                <Route path="/clients/:id" component={require('./pages/Client')}  />
                <Route path="/settings" component={require('./pages/MySettings')} />

                {/* When partners come onboard we want to take away the Fergus restriction */}
                <Route path="team" onEnter={canView('/team')}>
                    <IndexRoute component={require('./pages/admin/ManageUsers')} />
                </Route>

                <Route path="teams" onEnter={canView('/team')}>
                    <Route path="user/:id" component={require('./pages/admin/UserPage')}  />
                </Route>

                {/* OPE-112 discounts: promotions, coupons, codes, simulate billing */}
                <Route path="/discounts" onEnter={canView('/discounts')}>
                    <IndexRoute component={require('./pages/discounts/Coupons')} />
                    <Route path="coupons" component={require('./pages/discounts/Coupons')} />
                    <Route path="coupons/:id" component={require('./pages/discounts/Coupon')} />
                    <Route path="promotions" component={require('./pages/discounts/Promotions')} />
                    <Route path="promotions/:id" component={require('./pages/discounts/Promotion')} />
                    <Route path="simulate" component={require('./pages/discounts/Simulate')} />
                    <Route path="cmr" component={require('./pages/discounts/CmrReport')} />
                </Route>

                <Route path="/fergus-logs/supplier-documents" component={require('./pages/FergusLogs/SupplierDocuments')} />
                <Route path="/fergus-logs" component={require('./pages/FergusLogs')} />
            </Route>

            {/* Public routes */}
            <Route component={UnAuthenticatedLayout}>
                <Route path='/login' component={require('./pages/Login')} />
            </Route>

            <Route component={UnAuthenticatedLayout}>
                <Route path='/auth/google/handoff' component={require('./pages/GoogleHandoff')} />
            </Route>

            <Route component={UnAuthenticatedLayout}>
                <Route path='/logout' component={require('./pages/Logout')} />
            </Route>


            {/* Catch all route */}
            <Route path="*" component={require('./pages/NotFound')}/>
        </Route>
    );
};



// WEBPACK FOOTER //
// ./app/routes.js